import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Tab } from '../../../components';
import { ArchivedTab } from './ArchivedTab';
import { CompletedTab } from './CompletedTab';
import { IncompleteTab } from './IncompleteTab';
import { PendingTab } from './PendingTab';
import { ScheduledTab } from './ScheduledTab';
import * as S from './BookingsTab.styles';

export const BookingsTab = ({ group }) => {
	const [tabs, setTabs] = useState([
		{
			id: 1,
			label: 'Pending',
			component: <PendingTab group={group} />,
		},
		{
			id: 2,
			label: 'Scheduled',
			component: <ScheduledTab group={group} />,
		},
		{
			id: 3,
			label: 'Completed',
			component: <CompletedTab group={group} />,
		},
		{
			id: 4,
			label: 'Incomplete',
			component: <IncompleteTab group={group} />,
		},
		{
			id: 5,
			label: 'Archived',
			component: <ArchivedTab group={group} />,
		},
	]);

	return (
		<S.Wrapper>
			<Tab tabs={tabs} setTabs={setTabs} transparent variation="pill" />
		</S.Wrapper>
	);
};

BookingsTab.propTypes = {
	group: PropTypes.object,
};
